module.exports = __webpack_public_path__ + "res/Roboto-LightItalic-webfont.woff?9ca7aebd2052b13aebc09555efddd89a";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-LightItalic-webfont.woff
// module id = 68
// module chunks = 0